import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTipofalla, CedAsigequipo, crearTicket } from '../../redux/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import PacmanLoader from 'react-spinners/PacmanLoader';
import styles from './GenerarTicket.module.css';
import { FaLaptopCode, FaPaperPlane } from 'react-icons/fa';

const MySwal = withReactContent(Swal);

const GenerarTicket = () => {
    const dispatch = useDispatch();
    const tipofalla = useSelector((state) => state.tipofalla);
    const usuario = useSelector((state) => state.usuario);
    const asigusuario = useSelector((state) => state.asigusuario);

    const [codigo, setCodigo] = useState('');
    const [tipoFallaSeleccionado, setTipoFallaSeleccionado] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dispatch(getTipofalla());
    }, [dispatch]);

    useEffect(() => {
        if (usuario.usuario && usuario.usuario.cedula) {
            dispatch(CedAsigequipo(usuario.usuario.cedula))
                .catch((err) => {
                    if (err.response && err.response.status === 404) {
                        setError('Usuario no tiene asignaciones de equipo');
                    }
                });
        }
    }, [dispatch, usuario]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        const asignacionSeleccionada = asigusuario.find((a) => {
            return String(a.equipo.cod) === String(codigo);
        });

        const AsignacionId = asignacionSeleccionada ? asignacionSeleccionada.asignacion.id : null;

        if (!AsignacionId) {
            setError('No se pudo encontrar la asignación para el código seleccionado');
            return;
        }

        const nuevoTicket = {
            fecha: new Date().toISOString(),
            Observacion: observaciones,
            AsignacionId: AsignacionId,
            FallaId: tipoFallaSeleccionado,
            EstadoId: 1,
            nombreUsuario: usuario.usuario.nombre,
            correoUsuario: usuario.usuario.email,
            cod: asignacionSeleccionada.equipo.cod,
        };

        setLoading(true);

        try {
            const resultAction = await dispatch(crearTicket(nuevoTicket));
            if (crearTicket.fulfilled.match(resultAction)) {
                const ticketId = resultAction.payload.Ticket.id;
                setTimeout(() => {
                    setLoading(false);
                    MySwal.fire({
                        title: 'Ticket Generado',
                        text: `Se ha generado su ticket con el número ${ticketId}`,
                        icon: 'success',
                        confirmButtonText: 'Aceptar'
                    });
                }, 2000);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }

        setCodigo('');
        setTipoFallaSeleccionado('');
        setObservaciones('');
    };

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}><FaLaptopCode style={{ marginRight: '15px' }} /> Gestión TI</h2>
                <p className={styles.subtitle}>Reporta cualquier incidencia técnica con tu equipo de cómputo.</p>
            </header>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className={styles.formCard}>
                <form onSubmit={handleSubmit} className={styles.formGrid}>
                    <div className={styles.inputGroup}>
                        <label htmlFor="codigo" className={styles.label}>Código del Equipo</label>
                        <select
                            id="codigo"
                            className={styles.select}
                            value={codigo}
                            onChange={(e) => setCodigo(e.target.value)}
                            required
                        >
                            <option value="">Seleccionar equipo</option>
                            {asigusuario.length === 0 ? (
                                <option value="" disabled>No tiene equipo asignado</option>
                            ) : (
                                asigusuario.map((asignacion) => (
                                    <option key={asignacion.equipo.cod} value={asignacion.equipo.cod}>
                                        {asignacion.equipo.cod} - {asignacion.equipo.Tipoequipo.descripcionte}
                                    </option>
                                ))
                            )}
                        </select>
                    </div>

                    <div className={styles.inputGroup}>
                        <label htmlFor="tipoFalla" className={styles.label}>Tipo de Falla</label>
                        <select
                            id="tipoFalla"
                            className={styles.select}
                            value={tipoFallaSeleccionado}
                            onChange={(e) => setTipoFallaSeleccionado(e.target.value)}
                            required
                        >
                            <option value="">Seleccionar tipo</option>
                            {tipofalla.filter(falla => falla.tipo === 1).map((falla) => (
                                <option key={falla.id} value={falla.id}>
                                    {falla.descripcion}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={`${styles.inputGroup} ${styles.fullWidth}`}>
                        <label htmlFor="observaciones" className={styles.label}>Descripción del Problema</label>
                        <textarea
                            id="observaciones"
                            className={styles.textarea}
                            value={observaciones}
                            onChange={(e) => setObservaciones(e.target.value)}
                            rows={5}
                            placeholder="Describe detalladamente lo que sucede con tu equipo..."
                            required
                        />
                    </div>

                    <div className={`${styles.submitContainer} ${styles.fullWidth}`}>
                        <button type="submit" className={styles.submitButton}>
                            <FaPaperPlane /> Generar Ticket
                        </button>
                    </div>
                </form>
            </div>

            {loading && (
                <div className={styles.spinnerContainer}>
                    <PacmanLoader color="#3b82f6" loading={true} size={40} />
                </div>
            )}
        </div>
    );
};

export default GenerarTicket;
